import { render, staticRenderFns } from "./shadows.vue?vue&type=template&id=9d00bce0"
import script from "./shadows.vue?vue&type=script&lang=js"
export * from "./shadows.vue?vue&type=script&lang=js"
import style0 from "./shadows.vue?vue&type=style&index=0&id=9d00bce0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports